import React from 'react';
import { Link } from 'react-router-dom';
import { initiatives, initiativesIntro } from '../../data/aboutPage';
const buttonClass: Record<'green' | 'black', string> = {
  green: 'bg-success text-ink group-hover:bg-success-hover',
  black: 'bg-ink text-white group-hover:bg-white group-hover:text-ink'
};

// "About us / ES Initiatives" — two full-photo cards linking to ES Helps and Careers.
export function InitiativesGrid() {
  return <section aria-labelledby="initiatives-title" className="w-full bg-white px-2 py-2 md:px-4" data-id="element-41" data-mp="2zk5jenb1u8q8">
      <div className="rounded-[28px] bg-mist md:rounded-[40px]" data-id="element-42" data-mp="34hxji4lul15i">
        <div className="mx-auto max-w-content px-5 py-16 md:px-8 md:py-24" data-id="element-43" data-mp="399yvrqj0mrvj">
          <h2 id="initiatives-title" data-id="element-44" data-mp="3e92018r68u2g">
            <span className="block type-h2-light text-ink" data-id="element-45" data-mp="3e80eubgfyr70">About us</span>
            <span className="block type-h2 text-brand" data-id="element-46" data-mp="3ibf3trmcyhwl">ES Initiatives</span>
          </h2>
          <p className="mt-6 type-body text-ink" data-id="element-47" data-mp="3n9goui3cgrap">{initiativesIntro}</p>

          <ul className="mt-10 grid gap-3 md:mt-12 md:grid-cols-2" data-id="element-48" data-mp="3n7nfuw59duzj">
            {initiatives.map(item => <li key={item.title} data-id="element-49" data-mp="2uxms8y6zz3to">
                <Link to={item.to} className="group relative flex min-h-[380px] flex-col justify-end overflow-hidden rounded-[28px] p-6 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand md:min-h-[450px] md:rounded-[32px] md:p-9" data-id="element-50" data-mp="2uwk06mxxuvc6">
                  <img src={item.image} alt={item.alt} className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 ease-brand group-hover:scale-[1.03]" data-id="element-51" data-mp="3ilw8zlpct1dy" />
                  <div className="absolute inset-0 bg-black/35" aria-hidden="true" data-id="element-52" data-mp="33ykw9ghfrbc9" />
                  <h3 className="relative type-h2 text-white" data-id="element-53" data-mp="58b0kcudo3sp">{item.title}</h3>
                  <p className="relative mt-2 max-w-md type-feature-desc font-semibold text-white" data-id="element-54" data-mp="5ae0ppp8vdb5">{item.text}</p>
                  <span className={`relative mt-5 inline-flex h-12 w-fit items-center rounded-[15px] px-6 type-button font-bold transition-colors duration-150 ${buttonClass[item.tone]}`} data-id="element-55" data-mp="frlfbg1l0ls">
                    {item.cta}
                  </span>
                </Link>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}